import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-699FQ166JF";

let gaInitialized = false;

function initGa() {
  if (gaInitialized) return;
  gaInitialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  // send_page_view: false — gtag's automatic pageview only fires once,
  // on this initial load. It has no idea about React Router navigations,
  // so every route change below fires its own manual page_view event
  // instead of relying on that one.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

// Mounted only on the landing site (isLanding in App.js) — restaurant
// menus and the admin dashboard are not tracked by this.
function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    initGa();
  }, []);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: `${location.pathname}${location.search}`,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;
